// REMOVE PENDING ONCE ALL ORDERS ARE OUT OF PENDING STATUS
// TODO: Review enum values — some statuses (e.g. COMPLETED, DENIED) may no longer be in use https://taskei.amazon.dev/tasks/ShopHW-25
export enum HardwareOrderStatus { 
    ASSIGNED = "ASSIGNED",
    WORK_IN_PROGRESS = "WORK_IN_PROGRESS",
    PENDING = "PENDING",
    PENDING_QUOTE = "PENDING_QUOTE",
    PENDING_REQ_INFO = "PENDING_REQ_INFO",
    PENDING_APPROVAL = "PENDING_APPROVAL",
    PENDING_DELIVERY = "PENDING_DELIVERY",
    CANCELLED = "CANCELLED",
    COMPLETED = "COMPLETED",
    DENIED = "DENIED",
    APPROVED = "APPROVED",
    DELIVERED = "DELIVERED",
    REJECTED = "REJECTED",
    NEW = "NEW",
    // AMZNHAM-specific statuses
    PROCESSING = "PROCESSING",
    PENDING_SHIPPING = "PENDING_SHIPPING",
    SHIPPED = "SHIPPED"
}

export enum MANAGE_ORDER_TABS {
    ALL_HAM_ORDERS = '',
    ITSE_HAM_ORDERS = 'ITSE',
    AMAZONIAN_HAM_ORDERS = 'AMAZONIAN',
    IT_SHOP_ORDERS = 'it-shop-orders',
    IT_SHOP_ORDERS_SUPPORT_REQUESTED = 'it-shop-orders-support-requested'
};
